import React, { useContext, useEffect, useState } from "react";
import { Alert, Button, Container } from "react-bootstrap";
import { ensureSaSkuOrderable } from "../../components/cart/addToCartService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AxiosController from "../../components/authentication/AxiosController";
import { useTranslation } from "react-i18next";
import PlaceCartItem from "../../components/cart/PlaceCartItem";
import Loader from "../../components/loader/Loader";
import eid from "../../../src/imgs/eid.webp";
import { UserContext } from "../../components/contexts/UserContext";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import OfferCountdownTimer from "../../components/reuseable/OfferCountdownTimer";
import { isProductOfferActive } from "../../components/reuseable/ProductPriceDisplay";

const OrderNow = () => {
  const { slug, lang, productId, variant } = useParams();
  const location = useLocation();
  const Navigate = useNavigate();
  const urlParams = new URLSearchParams(location.search);
  const exclusiveParam = urlParams.get("exclusive");
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  if (token) {
  } else {
    Navigate(`/ar/auth/login`);
  }
  const [_] = useTranslation("global");
  const [cart, handleCart] = useState([]);
  const [governments, handleGovs] = useState([]);
  // const [governmentAreas, handleGovAreas] = useState([]);
  const [loading, handleLoader] = useState(false);

  const [shippingcost, handleShippingCost] = useState(0);

  // order data
  const [orderClientName, handleOrderClientName] = useState("");
  const [altName, setAltname] = useState("");
  const [orderClientNameErr, handleOrderClientNameErr] = useState("");
  const [orderClientPhone1, handleOrderClientPhone1] = useState("");
  const [orderClientPhone1Err, handleOrderClientPhone1Err] = useState("");
  const [orderClientPhone2, handleOrderClientPhone2] = useState("");
  const [orderClientGov, handleOrderClientGov] = useState(0);
  const [orderClientQuantity, handleOrderClientQuantity] = useState(1);
  const [orderClientPrice, handleOrderClientPrice] = useState(0);
  const [orderClientGovErr, handleOrderClientGovErr] = useState("");
  const [orderClientAddress, handleOrderClientAddress] = useState("");
  const [orderClientAddressErr, handleOrderClientAddressErr] = useState("");
  const [orderClientPublicNotes, handleOrderClientPublicNotes] = useState("");
  const [orderClientPrivateNotes, handleOrderClientPrivateNotes] = useState("");
  const [orderLink, setOrderLink] = useState("");
  const [COD, setCOD] = useState(0);
  const [orderLinkErr, setOrderLinkErr] = useState("");
  const [ref_order, setRef_order] = useState("");
  const [ref_orderErr, setRef_orderErr] = useState("");
  const [skuOrderBlocked, setSkuOrderBlocked] = useState(false);
  const { userData } = useContext(UserContext);

  // Helper to check if cart item has active category offer
  const hasActiveCategoryOffer = () => {
    if (!cart.has_category_offer || !cart.selling_price) return false;
    if (!cart.offer_valid_until) return true;
    const now = new Date();
    const endDate = new Date(cart.offer_valid_until);
    return endDate > now;
  };

  // Get the effective base price (selling_price if offer active, else price)
  const getEffectiveBasePrice = () => {
    return hasActiveCategoryOffer() ? cart.selling_price : cart.price;
  };

  const totalPrice = orderClientPrice * orderClientQuantity;
  const effectiveBasePrice = getEffectiveBasePrice();
  const totalCommission =
    (orderClientPrice -
      (effectiveBasePrice - (userData?.level_data?.commission ?? 0))) *
    orderClientQuantity;
  useEffect(() => {
    handleLoader(true);

    AxiosController.get(`api/${slug}/${lang}/get-variant-details/${variant}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(async (res) => {
        if (!res.data) Navigate(`/${slug}/${lang}`);
        handleCart(res.data);
        if (slug === "sa") {
          const canOrder = await ensureSaSkuOrderable({
            slug,
            lang,
            token,
            productId,
            variantId: variant,
            sku: res.data?.sku,
            exclusiveParam,
          });
          setSkuOrderBlocked(!canOrder);
        } else {
          setSkuOrderBlocked(false);
        }
        setAltname(res.data.alt_name.split(" ")[0]);
        handleOrderClientPrice(res.data.price);
        handleLoader(false);
      })
      .catch((e) => {
        handleLoader(false);
      });
    AxiosController.get(`api/${slug}/${lang}/get-shippingcost`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        handleGovs(res.data);
        handleShippingCost(res.data[0].cost);
        handleLoader(false);
      })
      .catch((e) => {
        handleLoader(false);
      });
  }, [slug, lang, token]);
  const placeOrder = async () => {
    const canOrder = await ensureSaSkuOrderable({
      slug,
      lang,
      token,
      productId,
      variantId: variant,
      sku: cart?.sku,
      exclusiveParam,
    });
    if (!canOrder) return;

    handleLoader(true);
    AxiosController.post(
      `api/${slug}/${lang}/place-order/`,
      {
        customer_name: orderClientName,
        phone_1: orderClientPhone1,
        phone_2: orderClientPhone2,
        gov_id: orderClientGov,
        public_notes: orderClientPublicNotes,
        private_notes: orderClientPrivateNotes,
        address: orderClientAddress,
        order_link: orderLink,
        COD: COD,
        reference_order: ref_order,

        variants: [
          {
            v_id: variant,
            price: orderClientPrice,
            quantity: orderClientQuantity,
          },
        ],
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => {
        handleLoader(false);
        Navigate(`/${slug}/${lang}/success-order`);
      })
      .catch((e) => { 
        const err = e.response?.data?.error;
        if (typeof err === "string") {
          handleLoader(false);
          return;
        }
        toast.error(err);
        handleOrderClientNameErr(
          e.response.data.error.customer_name
            ? e.response.data.error.customer_name[0]
            : ""
        );
        handleOrderClientPhone1Err(
          e.response.data.error.phone_1 ? e.response.data.error.phone_1[0] : ""
        );
        handleOrderClientGovErr(
          e.response.data.error.gov_id ? e.response.data.error.gov_id[0] : ""
        );
        handleOrderClientAddressErr(
          e.response.data.error.address ? e.response.data.error.address[0] : ""
        );
        setOrderLinkErr(
          e.response.data.error.order_link
            ? e.response.data.error.order_link[0]
            : ""
        );
        handleLoader(false);
      });
  };
  return (
    <Container style={{ position: "relative" }}>
      <Loader active={loading} />
      <Helmet>
        <title> {_("home.completeorder")}</title>
      </Helmet>
      <div className="add-product-container d-flex flex-column gap-2 my-3 px-4">
        {slug === "sa" && (
          <Alert variant="danger" className="text-center fw-bold">
            ( اعتبارا من 1 / 1 / 2026 لن يتم خروج اي طلب لشركات الشحن بدون العنوان الوطني السعودي short address و عليك عامل توفيره من خلال عميلك )
            <br /> الرجاء اضافته في بند ملاحظات تظهر للادارة
          </Alert>
        )}
        {skuOrderBlocked ? (
          <Alert variant="danger" className="text-center fw-bold">
            غير متوفر بالمخزن
          </Alert>
        ) : (
          ""
        )}
        <div className="add-header" dir={lang === "en" ? "ltr" : "rtl"}>
          <h2 className="mb-3" style={{ color: "rgba(89, 198, 201, 1)" }}>
            {_("home.completeorder")}
          </h2>
        </div>
        <div
          className="d-flex gap-5 flex-column-reverse flex-md-row"
          dir={lang === "en" ? "ltr" : "rtl"}
        >
          <div
            className="order-right-container d-flex flex-column"
            style={{ flex: "7" }}
          >
            <div className="order-right-entry">
              <div className="add-body1 d-flex flex-column flex-md-row gap-4 mb-4">
                <div
                  className="right-side d-flex flex-column"
                  style={{ flex: "3" }}
                >
                  <div className="right-head">
                    <h3>{_("home.customerdetails")}</h3>
                    <p>{_("home.verifydata")}</p>
                  </div>
                  {["fulfillment"].includes(role) ? (
                    <div className="mb-3">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        {_("panel.orderLink")}
                      </label>
                      {orderLinkErr ? (
                        <Alert variant={"danger"}>{ref_orderErr}</Alert>
                      ) : (
                        ""
                      )}
                      <input
                        type="text"
                        className="form-control py-2 px-3 egp"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        value={ref_order}
                        onInput={(e) => setRef_order(e.target.value)}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {["admin", "employee"].includes(role) ? (
                    <div className="mb-3">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        {_("panel.orderLink")}
                      </label>
                      {orderLinkErr ? (
                        <Alert variant={"danger"}>{orderLinkErr}</Alert>
                      ) : (
                        ""
                      )}
                      <input
                        type="text"
                        className="form-control py-2 px-3 egp"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        value={orderLink}
                        onInput={(e) => setOrderLink(e.target.value)}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.fullname")}
                    </label>
                    {orderClientNameErr ? (
                      <Alert variant={"danger"}>{orderClientNameErr}</Alert>
                    ) : (
                      ""
                    )}
                    <input
                      type="text"
                      className="form-control py-2 px-3 egp"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      value={orderClientName}
                      onInput={(e) => handleOrderClientName(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.phonenumber")}
                    </label>
                    {orderClientPhone1Err ? (
                      <Alert variant={"danger"}>{orderClientPhone1Err}</Alert>
                    ) : (
                      ""
                    )}
                    <input
                      type="text"
                      className="form-control py-2 px-3 egp"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      value={orderClientPhone1}
                      onInput={(e) => handleOrderClientPhone1(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.phonenumber2")}
                    </label>
                    <input
                      type="text"
                      className="form-control py-2 px-3 egp"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      value={orderClientPhone2}
                      onInput={(e) => handleOrderClientPhone2(e.target.value)}
                    />
                  </div>
                  <div className="mb-3 d-flex gap-2">
                    <div className="flex-grow-1">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        {_("home.quantity")}
                      </label>
                      <input
                        type="number"
                        className="form-control py-2 px-3 egp"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        value={orderClientQuantity}
                        onInput={(e) =>
                          handleOrderClientQuantity(e.target.value)
                        }
                      />
                    </div>
                    {role != "fulfillment" ? (
                      <div className="flex-grow-1">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label"
                        >
                          {_("home.price")} ({_("home.minimum")} {cart.price})
                        </label>
                        <input
                          type="number"
                          className="form-control py-2 px-3 egp"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          value={orderClientPrice}
                          onInput={(e) =>
                            handleOrderClientPrice(e.target.value)
                          }
                        />
                      </div>
                    ) : (
                      <div className="flex-grow-1">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label"
                        >
                          {_("home.COD")}
                        </label>
                        <input
                          type="number"
                          className="form-control py-2 px-3 egp"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          value={COD}
                          onInput={(e) => setCOD(e.target.value)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="order-right-entry">
              <div className="add-body1 d-flex flex-column flex-md-row gap-4 mb-4">
                <div
                  className="right-side d-flex flex-column"
                  style={{ flex: "7" }}
                >
                  <div className="right-head">
                    <h3>{_("home.shippingdetails")}</h3>
                    <p>{_("home.verifydata")}</p>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.province")}
                    </label>
                    {orderClientGovErr ? (
                      <Alert variant={"danger"}>{orderClientGovErr}</Alert>
                    ) : (
                      ""
                    )}
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      onChange={(e) => {
                        handleOrderClientGov(
                          e.target.options[e.target.selectedIndex].id
                        );
                        handleShippingCost(e.target.value);
                      }}
                    >
                      <option value={0}></option>
                      {governments.map((gov) => {
                        return (
                          <option value={gov.cost} id={gov.id}>
                            {gov.arabic_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.address")}
                    </label>
                    {orderClientAddressErr ? (
                      <Alert variant={"danger"}>{orderClientAddressErr}</Alert>
                    ) : (
                      ""
                    )}
                    <textarea
                      className="form-control py-2 px-3 egp"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      rows="4"
                      value={orderClientAddress}
                      onInput={(e) => handleOrderClientAddress(e.target.value)}
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.notesforclient")}
                    </label>
                    <textarea
                      className="form-control py-2 px-3 egp"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      rows="4"
                      value={orderClientPublicNotes}
                      onInput={(e) =>
                        handleOrderClientPublicNotes(e.target.value)
                      }
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      {_("home.notesformangment")}
                    </label>
                    <textarea
                      className="form-control py-2 px-3 egp"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      rows="4"
                      value={orderClientPrivateNotes}
                      onInput={(e) =>
                        handleOrderClientPrivateNotes(e.target.value)
                      }
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="order-info d-flex flex-column gap-3"
            style={{ height: "100%", flexGrow: 1 }}
          >
            <div
              className="left-side d-flex flex-column align-items-center text-center py-4 px-4 gap-2"
              style={{ height: "100%", flexGrow: 1, width: "100%" }}
            >
              <div className="top py-3">
                <h3>{_("home.ordersummary")}</h3>
              </div>
              <div
                className="left-body py-2 d-flex flex-column gap-3"
                style={{ minWidth: "100%" }}
              >
                <div className="sku_info d-flex flex-sm-row gap-2 align-items-center">
                  <img
                    src={cart.thumbnail}
                    width="30px"
                    style={{ flexGrow: 1, borderRadius: "10px" }}
                    alt=""
                  />
                  <div className="sku_info_text flex-grow-1">
                    <p style={{ color: "rgba(23, 43, 77, 1)" }}>{cart.title}</p>
                    <p>عدد {orderClientQuantity}</p>
                  </div>
                  <div
                    className="sku_info_text flex-grow-1"
                    style={{ color: "rgba(89, 198, 201, 1)" }}
                  >
                    <p>{_("home.price")}</p>
                    {cart.has_category_offer && cart.selling_price && isProductOfferActive({ has_category_offer: cart.has_category_offer, selling_price: cart.selling_price, offer_valid_until: cart.offer_valid_until }) ? (
                      <div className="d-flex flex-column">
                        <p className="mb-0">
                          <del className="text-secondary" style={{ fontSize: "0.85em" }}>
                            {cart.price} {altName}
                          </del>
                        </p>
                        <p className="mb-0" style={{ color: "#dc3545", fontWeight: "bold" }}>
                          {cart.selling_price} {altName}
                        </p>
                        <OfferCountdownTimer 
                          offerValidUntil={cart.offer_valid_until} 
                          compact={true}
                        />
                      </div>
                    ) : (
                      <p>
                        {orderClientPrice -
                          (userData?.level_data?.commission ?? 0)}{" "}
                        {altName}
                      </p>
                    )}
                  </div>
                </div>
                <div className="pricing-info d-flex flex-column">
                  {role != "fulfillment" ? (
                    <>
                      <div className="price-row d-flex justify-content-between p-3">
                        <p
                          className="fs-5"
                          style={{ color: "rgba(23, 43, 77, 1)" }}
                        >
                          {_("home.shippingcost")}
                        </p>
                        <p>
                          {shippingcost} {altName}
                        </p>
                      </div>
                      <div className="price-row d-flex justify-content-between p-3">
                        <p
                          className="fs-5"
                          style={{ color: "rgba(23, 43, 77, 1)" }}
                        >
                          {_("home.tax")}
                        </p>
                        <p>0 {altName}</p>
                      </div>
                      <div className="price-row d-flex justify-content-between p-3">
                        <p
                          className="fs-5"
                          style={{ color: "rgba(23, 43, 77, 1)" }}
                        >
                          {_("home.commission")}
                        </p>
                        <p>
                          {totalCommission} {altName}
                        </p>
                      </div>
                      <div className="price-row d-flex justify-content-between p-3">
                        <p
                          className="fs-5"
                          style={{ color: "rgba(23, 43, 77, 1)" }}
                        >
                          {_("home.price")}
                        </p>
                        <p>
                          {totalPrice - totalCommission} {altName}
                        </p>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <div className="price-row d-flex justify-content-between p-3">
                    <p
                      className="fs-5"
                      style={{ color: "rgba(23, 43, 77, 1)" }}
                    >
                      {_("home.totalprice")}
                    </p>
                    <p>
                      {role == "fulfillment"
                        ? COD
                        : totalPrice + parseInt(shippingcost)}{" "}
                      {altName}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <Button
                style={{
                  backgroundColor: "rgba(89, 198, 201, 1)",
                  color: "white",
                  border: "none",
                  width: "100%",
                }}
                className="fs-5"
                onClick={() => {
                  placeOrder();
                }}
                disabled={skuOrderBlocked}
              >
                {_("panel.addorder")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default OrderNow;
